
import { SOCIAL_PLATFORMS_METADATA } from '@/constants';
import { PlatformMetadata } from '@/types';
import { Post, PostImage, PostPublishInfo } from 'ignite360-core';
import { Component, Prop, Vue } from 'vue-property-decorator';

type PostImageRow = PostImage & { type?: 'image' | 'video' };

@Component({
  name: 'posts-list-card-item',
})
export default class PostsListCardItem extends Vue {
  @Prop({ required: true, type: Object })
  post!: Post;

  get imageAsset(): PostImageRow | null {
    const image = this.post.image;
    return image && typeof image === 'object' ? (image as PostImageRow) : null;
  }

  get imageUrl(): string {
    return this.imageAsset?.url || '';
  }

  get isVideoAsset(): boolean {
    const type = this.imageAsset?.type;
    if (type === 'video') {
      return true;
    }
    return this.imageUrl.toLowerCase().includes('.mp4');
  }

  get relatedPlatformMetadata(): PlatformMetadata[] {
    if (!this.post.publishInfo) return [];
    const relatedMetadataList: PlatformMetadata[] = [];

    for (const key in this.post.publishInfo) {
      if (this.post.publishInfo[key as keyof PostPublishInfo]) {
        const relatedMetadata = SOCIAL_PLATFORMS_METADATA.find(
          (metadata) => metadata.value === key,
        );
        if (relatedMetadata) {
          relatedMetadataList.push(relatedMetadata);
        }
      }
    }

    return relatedMetadataList;
  }
}
